// Global vehicle selection object
window.VehicleSelection = {
  make: null,
  lineup: null,
  model: null,
  isComplete: false,
  storageKey: 'vehicleSelection',
  
  // Reset all selections
  reset: function() {
    this.make = null;
    this.lineup = null;
    this.model = null;
    this.isComplete = false;
    this.isFromStorage = false;
    this.saveToStorage();
  },
  
  // Save current state to localStorage
  saveToStorage: function() {
    try {
      const state = {
        make: this.make,
        lineup: this.lineup,
        model: this.model,
        isComplete: this.isComplete,
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save vehicle selection to localStorage:', error);
    }
  },
  
  // Load state from localStorage
  loadFromStorage: function() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const state = JSON.parse(stored);
        this.make = state.make;
        this.lineup = state.lineup;
        this.model = state.model;
        this.isComplete = state.isComplete || false;
        this.isFromStorage = true;
        
        // Dispatch event if we loaded a complete selection
        if (this.isComplete) {
          setTimeout(() => {
            const event = new CustomEvent('vehicleSelectionLoadedFromStorage', {
              detail: {
                make: this.make,
                lineup: this.lineup,
                model: this.model,
                fullSelection: this.getFullSelection(),
                timestamp: state.timestamp
              }
            });
            document.dispatchEvent(event);
          }, 100);
        }
        
        return state;
      }
    } catch (error) {
      console.warn('Failed to load vehicle selection from localStorage:', error);
    }
    return null;
  },
  
  // Clear localStorage
  clearStorage: function() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {
      console.warn('Failed to clear vehicle selection from localStorage:', error);
    }
  },
  
  // Set make selection
  setMake: function(makeText, makeIndex) {
    this.make = {
      text: makeText,
      index: makeIndex
    };
    // Reset dependent selections
    this.lineup = null;
    this.model = null;
    this.isComplete = false;
    this.saveToStorage();
  },
  
  // Set lineup selection
  setLineup: function(lineupText, lineupIndex, makeIndex) {
    this.lineup = {
      text: lineupText,
      index: lineupIndex,
      makeIndex: makeIndex
    };
    // Reset dependent selection
    this.model = null;
    this.isComplete = false;
    this.saveToStorage();
  },
  
  // Set model selection
  setModel: function(modelText, modelIndex, lineupIndex, makeIndex) {
    this.model = {
      text: modelText,
      index: modelIndex,
      lineupIndex: lineupIndex,
      makeIndex: makeIndex
    };
    this.isComplete = true;
    this.saveToStorage();
    
    // Trigger completion event
    this.onComplete();
  },
  
  // Completion callback
  onComplete: function() {
    // Dispatch custom event
    const event = new CustomEvent('vehicleSelectionComplete', {
      detail: {
        make: this.make,
        lineup: this.lineup,
        model: this.model,
        fullSelection: this.getFullSelection()
      }
    });
    document.dispatchEvent(event);
  },
  
  // Get complete selection object
  getFullSelection: function() {
    return {
      make: this.make,
      lineup: this.lineup,
      model: this.model,
      isComplete: this.isComplete,
      displayText: this.getDisplayText(),
      fromStorage: this.isFromStorage || false
    };
  },
  
  // Get storage information
  getStorageInfo: function() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const state = JSON.parse(stored);
        return {
          exists: true,
          timestamp: state.timestamp,
          isComplete: state.isComplete || false,
          displayText: state.isComplete ? 
            `${state.make?.text || ''} ${state.lineup?.text || ''} ${state.model?.text || ''}`.trim() : 
            'Incomplete Selection'
        };
      }
    } catch (error) {
      console.warn('Failed to get storage info:', error);
    }
    return { exists: false };
  },
  
  // Get formatted display text
  getDisplayText: function() {
    if (!this.isComplete) return 'Incomplete Selection';
    return `${this.make.text} ${this.lineup.text} ${this.model.text}`;
  }
};

// Smooth scroll to top function
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// Function to open vehicle modal (for mobile menu)
function openVehicleModal() {
  const vehicleModal = document.getElementById('vehicle-modal');
  const modalContent = document.getElementById('vehicle-modal-content');
  const vehicleMenu = document.querySelector('.vehicle-content .select-your-vehicle, .vehicle-content .select-your-vehicle-filter') || 
                     document.querySelector('#vehicle-content-filter .select-your-vehicle, #vehicle-content-filter .select-your-vehicle-filter');
  
  const modalCloseBtn = vehicleModal ? vehicleModal.querySelector('.vehicle-modal__close') : null;
  
  if (vehicleMenu && modalContent && vehicleModal) {
    // Close the mobile menu first
    const mobileMenuDetails = document.getElementById('Details-menu-drawer-container');
    if (mobileMenuDetails) {
      mobileMenuDetails.removeAttribute('open');
    }
    
    // Wait a moment for the mobile menu to close, then open vehicle modal
    setTimeout(() => {
      // Move content to modal
      modalContent.innerHTML = '';
      modalContent.appendChild(vehicleMenu.cloneNode(true));
      
      // Reset vehicle selection when opening modal
      window.VehicleSelection.reset();
      
      // Initialize unlocked levels (start with level 1)
      vehicleModal.dataset.unlockedLevels = JSON.stringify([1]);
      
      // Open modal
      /** @type {HTMLDialogElement} */ (vehicleModal).showModal();

      // Position modal to the right after opening
      setTimeout(() => {
        vehicleModal.style.position = 'fixed';
        vehicleModal.style.top = '0';
        vehicleModal.style.right = '0';
        vehicleModal.style.left = 'auto';
        vehicleModal.style.margin = '0';
        vehicleModal.style.transform = 'none';
      }, 0);

      // Show first level initially on mobile
      showMobileLevel(/** @type {HTMLDialogElement} */ (vehicleModal), 1);

      // Wait a bit for modal to render, then initialize event listeners for the cloned content
      setTimeout(() => {
        addModalNavigationHandlers(/** @type {HTMLDialogElement} */ (vehicleModal));
        initializeVehicleSelectionForModal(/** @type {HTMLDialogElement} */ (vehicleModal));
      }, 100);
      
      // Focus the close button for accessibility
      if (modalCloseBtn) {
        /** @type {HTMLElement} */ (modalCloseBtn).focus();
      }
    }, 150); // Small delay to allow mobile menu to close
  }
}

// Function to manage level visibility on mobile
/**
 * @param {HTMLDialogElement} modal
 * @param {number} activeLevel
 */
function manageMobileLevelVisibility(modal, activeLevel) {
  const levels = ['.first-level', '.second-level', '.third-level'];
  levels.forEach((level, index) => {
    const element = modal.querySelector(level);
    if (element) {
      // Use CSS classes instead of inline styles to match our unified handlers
      if (index + 1 === activeLevel) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    }
  });
}

// Function to show level with back navigation on mobile
/**
 * @param {HTMLDialogElement} modal
 * @param {number} targetLevel
 */
function showMobileLevel(modal, targetLevel) {
  manageMobileLevelVisibility(modal, targetLevel);
  
  // Get the current unlocked levels from the modal data
  const unlockedLevels = modal.dataset.unlockedLevels ? JSON.parse(modal.dataset.unlockedLevels) : [1];
  
  const levelButtons = ['.first-level-btn', '.second-level-btn', '.third-level-btn'];
  levelButtons.forEach((btnClass, index) => {
    const btn = modal.querySelector(btnClass);
    if (btn) {
      const isActiveLevel = index + 1 === targetLevel;
      btn.classList.toggle('active', isActiveLevel);
      
      // Enable buttons based on unlocked levels
      if (unlockedLevels.includes(index + 1)) {
        /** @type {HTMLButtonElement} */ (btn).disabled = false;
        btn.classList.remove('btn-disabled');
        /** @type {HTMLElement} */ (btn).style.borderTopColor = 'transparent';
      } else {
        /** @type {HTMLButtonElement} */ (btn).disabled = true;
        /** @type {HTMLElement} */ (btn).style.borderTopColor = '#9a9a9a';
      }
    }
  });
  
  // Also manage the chevron icons
  const levelIcons = ['.first-level-btn .chevron-toggle', '.second-level-btn .chevron-toggle', '.third-level-btn .chevron-toggle'];
  levelIcons.forEach((iconClass, index) => {
    const icon = modal.querySelector(iconClass);
    if (icon) {
      icon.classList.toggle('active', index + 1 === targetLevel);
    }
  });
}

// Apply vehicle filters by checking metaobject filter checkboxes
function applyVehicleFilters() {
  
  const selection = window.VehicleSelection.getFullSelection();
  
  if (!selection.isComplete || !selection.make || !selection.lineup || !selection.model) {
    return;
  }
  
  // Helper function to find checkbox by exact data-label match
  function findCheckboxByLabel(labelText) {
    const allCheckboxes = document.querySelectorAll(`input[type="checkbox"][data-label="${labelText}" i]`);
    
    for (const checkbox of allCheckboxes) {
      const checkboxLabel = checkbox.getAttribute('data-label');
      if (checkboxLabel?.toLowerCase() === labelText.toLowerCase()) {
        return checkbox;
      }
    }
    return null;
  }
  
  // First, uncheck all vehicle filter checkboxes
  document.querySelectorAll('input[name="filter.p.m.custom.vehicle_make"]').forEach(cb => cb.checked = false);
  document.querySelectorAll('input[name="filter.p.m.custom.vehicle_lineup"]').forEach(cb => cb.checked = false);
  document.querySelectorAll('input[name="filter.p.m.custom.vehicle_model"]').forEach(cb => cb.checked = false);
  
  // Then check the selected ones
  const makeCheckbox = findCheckboxByLabel(selection.make.text);
  if (makeCheckbox) {
    makeCheckbox.checked = true;
  }
  
  const lineupCheckbox = findCheckboxByLabel(selection.lineup.text);
  if (lineupCheckbox) {
    lineupCheckbox.checked = true;
  }
  
  const modelCheckbox = findCheckboxByLabel(selection.model.text);
  if (modelCheckbox) {
    modelCheckbox.checked = true;
  }
  
  // Now trigger the filter update once with all three checkboxes checked
  // Find the facets form instead of individual components
  const facetsForm = document.querySelector('facets-form-component');
  
  if (facetsForm && typeof facetsForm.updateFilters === 'function') {
    facetsForm.updateFilters();
  }
}

// Initialize LI availability styling from hidden inputs
/**
 * @param {string} inputId
 */
function parseAvailableList(inputId) {
  const el = document.getElementById(inputId);
  if (!el || !el.value) return new Set();
  return new Set(
    el.value
      .split('|')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean)
  );
}

/**
 * @param {HTMLElement} li
 */
function disableVehicleLi(li) {
  li.classList.add('disabled');
  li.setAttribute('aria-disabled', 'true');
  li.setAttribute('tabindex', '-1');
}

/**
 * @param {HTMLElement} li
 */
function enableVehicleLi(li) {
  li.classList.remove('disabled');
  li.removeAttribute('aria-disabled');
  li.removeAttribute('tabindex');
}

/**
 * @param {Document | HTMLElement} [container=document]
 */
function initVehicleAvailability() {
  console.log('initVehicleAvailability');
  const container = document.querySelector('.select-your-vehicle-filter');
  
  if(!container) return;
  const availMakes = parseAvailableList('available-makes');
  const availLineups = parseAvailableList('available-lineups');
  const availModels = parseAvailableList('available-models');
  const productCountElement = document.getElementById('collection-product-count');
  const productCount = productCountElement ? parseInt(productCountElement.value) : 0;
  const MAX_PRODUCT_COUNT = 5000;

  // Makes
  if(productCount <MAX_PRODUCT_COUNT){
    container.querySelectorAll('li[data-vehicle-make]').forEach((li) => {
      const key = li.getAttribute('data-vehicle-make');
      const normalized = key ? key.trim().toLowerCase() : '';
      if (normalized && availMakes.has(normalized)) {
        enableVehicleLi(li);
      } else {
        disableVehicleLi(li);
      }
    });
  }

  // Lineups
  if(productCount <MAX_PRODUCT_COUNT){
    container.querySelectorAll('li[data-vehicle-lineup]').forEach((li) => {
      const key = li.getAttribute('data-vehicle-lineup');
      const normalized = key ? key.trim().toLowerCase() : '';
      if (normalized && availLineups.has(normalized)) {
        enableVehicleLi(li);
      } else {
        disableVehicleLi(li);
      }
    });
  }

  // Models
  container.querySelectorAll('li[data-vehicle-model]').forEach((li) => {
    if (productCount > 5000){
      const a = document.createElement('a');
      a.href =  li.getAttribute('data-source-collection');
      a.textContent = li.textContent;
      li.removeChild(li.firstChild);
      li.appendChild(a);
    }else{
      const key = li.getAttribute('data-vehicle-model');
      const normalized = key ? key.trim().toLowerCase() : '';
      if (normalized && availModels.has(normalized)) {
        enableVehicleLi(li);
      } else {
        //disableVehicleLi(li);
        //enableVehicleLi(li);
        const a = document.createElement('a');
        a.href =  li.getAttribute('data-source-collection');
        a.textContent = li.textContent;
        li.removeChild(li.firstChild);
        li.appendChild(a);
      }
    }
  });
}

// Clear vehicle selection when filters are cleared
function clearVehicleSelection() {
  // Reset the vehicle selection state
  window.VehicleSelection.reset();
  
  // Clear the filter button summary
  const summaryElement = document.querySelector('.vehicle-selection-summary');
  if (summaryElement) {
    summaryElement.textContent = '';
    summaryElement.style.display = 'none';
  }
  
  // Reset the filter button text
  const filterButton = document.getElementById('vehicle-selector-filter-btn');
  if (filterButton) {
    const buttonText = filterButton.querySelector('span:not(.vehicle-selection-summary):not(.chevron-toggle)');
    if (buttonText) {
      buttonText.textContent = 'SELECT YOUR VEHICLE';
    }
  }
  
  // Reset all level buttons in filter dropdown
  const filterContainer = document.querySelector('.select-your-vehicle-filter');
  if (filterContainer) {
    // Reset button texts
    const firstLevelBtn = filterContainer.querySelector('.first-level-btn span');
    const secondLevelBtn = filterContainer.querySelector('.second-level-btn span');
    const thirdLevelBtn = filterContainer.querySelector('.third-level-btn span');
    
    if (firstLevelBtn) firstLevelBtn.textContent = 'MAKE';
    if (secondLevelBtn) secondLevelBtn.textContent = 'LINEUP';
    if (thirdLevelBtn) thirdLevelBtn.textContent = 'MODEL';
    
    // Disable lineup and model buttons
    const lineupBtn = filterContainer.querySelector('.second-level-btn');
    const modelBtn = filterContainer.querySelector('.third-level-btn');
    
    if (lineupBtn) {
      lineupBtn.disabled = true;
      lineupBtn.classList.add('btn-disabled');
    }
    if (modelBtn) {
      modelBtn.disabled = true;
      modelBtn.classList.add('btn-disabled');
    }
    
    // Collapse all levels
    filterContainer.querySelectorAll('.first-level, .second-level, .third-level').forEach(level => {
      level.classList.remove('active');
    });
    
    // Remove selected class from all list items
    filterContainer.querySelectorAll('li.selected').forEach(item => {
      item.classList.remove('selected');
    });
  }
}

// Update filter button summary with selected vehicle
function updateFilterSummary() {
  const summaryElement = document.querySelector('.vehicle-selection-summary');
  const filterButton = document.getElementById('vehicle-selector-filter-btn');
  if (!summaryElement) return;
  
  const selection = window.VehicleSelection.getFullSelection();
  
  if (selection.isComplete && selection.make && selection.lineup && selection.model) {
    const summaryText = `${selection.make.text} | ${selection.lineup.text} | ${selection.model.text}`;
    summaryElement.textContent = summaryText;
    summaryElement.style.display = 'block';
    
    // Add title attribute to the filter button for native browser tooltip
    if (filterButton) {
      filterButton.setAttribute('title', summaryText);
    }
  } else {
    summaryElement.style.display = 'none';
    
    // Remove title attribute when no selection
    if (filterButton) {
      filterButton.removeAttribute('title');
    }
  }
}

// Restore vehicle summary and dropdown state from URL or localStorage after section re-renders
function restoreVehicleSelectionState(skipIfClearing = false) {
  // Check if we're in the middle of clearing all filters
  if (skipIfClearing && window.isClearingAllFilters) {
    return;
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  
  // Check if vehicle filters are in the URL
  const makeParams = urlParams.getAll('filter.p.m.custom.vehicle_make');
  const lineupParams = urlParams.getAll('filter.p.m.custom.vehicle_lineup');
  const modelParams = urlParams.getAll('filter.p.m.custom.vehicle_model');
  
  let makeLabel, lineupLabel, modelLabel;
  
  // Prioritize URL parameters over localStorage
  if (makeParams.length > 0 && lineupParams.length > 0 && modelParams.length > 0) {
    // Find checkboxes by their value (metaobject ID) and get the data-label
    const makeCheckbox = document.querySelector(`input[type="checkbox"][value="${makeParams[0]}"]`);
    const lineupCheckbox = document.querySelector(`input[type="checkbox"][value="${lineupParams[0]}"]`);
    const modelCheckbox = document.querySelector(`input[type="checkbox"][value="${modelParams[0]}"]`);
    
    makeLabel = makeCheckbox?.getAttribute('data-label');
    lineupLabel = lineupCheckbox?.getAttribute('data-label');
    modelLabel = modelCheckbox?.getAttribute('data-label');
    
    // If we couldn't find labels from checkboxes, abort
    if (!makeLabel || !lineupLabel || !modelLabel) {
      return;
    }
  } else {
    // Fall back to localStorage
    const selection = window.VehicleSelection.getFullSelection();
    
    // Check if we have a complete vehicle selection
    if (!selection.isComplete || !selection.make || !selection.lineup || !selection.model) {
      return;
    }
    
    makeLabel = selection.make.text;
    lineupLabel = selection.lineup.text;
    modelLabel = selection.model.text;
  }
  
  const summaryElement = document.querySelector('.vehicle-selection-summary');
  const filterButton = document.getElementById('vehicle-selector-filter-btn');
  
  // Update the summary span
  if (summaryElement) {
    setTimeout(() => {
      const summaryText = `${makeLabel} | ${lineupLabel} | ${modelLabel}`;
      summaryElement.textContent = summaryText;
      summaryElement.style.display = 'block';
      
      if (filterButton) {
        filterButton.setAttribute('title', summaryText);
      }

       // Restore the visual state of the filter dropdown
       const filterContainer = document.querySelector('.select-your-vehicle-filter');
       if (filterContainer) {
         // Collapse all levels first
         const levels = [
           filterContainer.querySelector('.first-level'),
           filterContainer.querySelector('.second-level'),
           filterContainer.querySelector('.third-level')
         ];
         
         levels.forEach(level => level?.classList.remove('active'));
         
         // Update button texts to show selections
         const buttonSpans = [
           { element: filterContainer.querySelector('.first-level-btn span'), text: `MAKE - ${makeLabel.toUpperCase()}` },
           { element: filterContainer.querySelector('.second-level-btn span'), text: `LINEUP - ${lineupLabel.toUpperCase()}` },
           { element: filterContainer.querySelector('.third-level-btn span'), text: `MODEL - ${modelLabel.toUpperCase()}` }
         ];
        
        buttonSpans.forEach(({ element, text }) => {
          if (element) element.textContent = text;
        });
        
        // Enable the lineup and model buttons
        const buttons = [
          filterContainer.querySelector('.second-level-btn'),
          filterContainer.querySelector('.third-level-btn')
        ];
        
        buttons.forEach(btn => {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('btn-disabled');
          }
        });
        
        // Set chevron directions - all collapsed levels point down
        const chevrons = [
          filterContainer.querySelector('.first-level-btn .chevron-toggle'),
          filterContainer.querySelector('.second-level-btn .chevron-toggle'),
          filterContainer.querySelector('.third-level-btn .chevron-toggle')
        ];
        
        chevrons.forEach(chevron => {
          if (chevron) {
            chevron.classList.remove('chevron-up');
            chevron.classList.add('chevron-down');
          }
        });
        
        // Highlight the selected items in each level using data attributes
        const selectedItems = [
          { selector: `[data-vehicle-make="${makeLabel}"]`, label: 'Make' },
          { selector: `[data-vehicle-lineup="${lineupLabel}"]`, label: 'Lineup' },
          { selector: `[data-vehicle-model="${modelLabel}"]`, label: 'Model' }
        ];
        
        selectedItems.forEach(({ selector }) => {
          const item = filterContainer.querySelector(selector);
          if (item) item.classList.add('selected');
        });
      }
    },1000);
  }
}

// Add navigation button handlers for modal
function addModalNavigationHandlers(modal) {
  if (!modal) return;
  
  // Add click handlers for level navigation buttons
  const firstLevelBtn = modal.querySelector('.first-level-btn');
  const secondLevelBtn = modal.querySelector('.second-level-btn');
  const thirdLevelBtn = modal.querySelector('.third-level-btn');
  
  if (firstLevelBtn) {
    firstLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      showMobileLevel(modal, 1);
    });
  }
  
  if (secondLevelBtn) {
    secondLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!secondLevelBtn.disabled) {
        showMobileLevel(modal, 2);
      }
    });
  }
  
  if (thirdLevelBtn) {
    thirdLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!thirdLevelBtn.disabled) {
        showMobileLevel(modal, 3);
      }
    });
  }
}

// Helper function to get vehicle selector containers (both regular and filter modes)
function getVehicleContainerSelectors(baseSelector, isInModal) {
  const containerSelectors = [];
  
  if (isInModal) {
    // In modal, look for both container types
    containerSelectors.push('.select-your-vehicle', '.select-your-vehicle-filter');
  } else {
    // Outside modal, look in vehicle-content for both container types
    containerSelectors.push('.vehicle-content .select-your-vehicle', '.vehicle-content .select-your-vehicle-filter');
  }
  
  return containerSelectors;
}

// Helper function to get context-aware selectors
/**
 * @param {HTMLDialogElement | null} modal
 * @param {boolean} isInModal
 */
function getContextSelectors(modal, isInModal) {
  const baseSelector = isInModal ? modal : document;
  if (!baseSelector) return {};
  
  const containerSelectors = getVehicleContainerSelectors(baseSelector, isInModal);
  const containerSelector = containerSelectors.join(', ');
  
  // Create selectors that work with both container types
  const createSelector = (suffix) => {
    return containerSelectors.map(container => `${container} ${suffix}`).join(', ');
  };
  
  return {
    firstLevelItems: baseSelector.querySelectorAll(createSelector('.first-level li')),
    secondLevelItems: baseSelector.querySelectorAll(createSelector('.second-level li')),
    thirdLevelItems: baseSelector.querySelectorAll(createSelector('.third-level li')),
    secondLevelUls: baseSelector.querySelectorAll(createSelector('.second-level ul')),
    thirdLevelUls: baseSelector.querySelectorAll(createSelector('.third-level ul')),
    secondLevelContainer: baseSelector.querySelector(createSelector('.second-level')),
    firstLevelBtnSpan: baseSelector.querySelector('.first-level-btn span'),
    secondLevelBtnSpan: baseSelector.querySelector('.second-level-btn span'),
    thirdLevelBtnSpan: baseSelector.querySelector('.third-level-btn span'),
    firstLevel: baseSelector.querySelector(createSelector('.first-level')),
    secondLevel: baseSelector.querySelector(createSelector('.second-level')),
    thirdLevel: baseSelector.querySelector(createSelector('.third-level')),
    firstLevelBtn: baseSelector.querySelector('.first-level-btn'),
    secondLevelBtn: baseSelector.querySelector('.second-level-btn'),
    thirdLevelBtn: baseSelector.querySelector('.third-level-btn'),
    firstLevelBtnIcon: baseSelector.querySelector('.first-level-btn .chevron-toggle'),
    secondLevelBtnIcon: baseSelector.querySelector('.second-level-btn .chevron-toggle'),
    thirdLevelBtnIcon: baseSelector.querySelector('.third-level-btn .chevron-toggle')
  };
}

// Specialized initialization function for modal context
/**
 * @param {HTMLDialogElement} modal
 */
function initializeVehicleSelectionForModal(modal) {
  if (!modal) return;
  
  // Force modal context since we know we're in the modal
  const selectors = getContextSelectors(modal, true);
  
  // Initialize click handlers for the cloned content
  initializeClickHandlers(selectors, modal, true);
}

// Unified handler for make selection (works for both header and filter versions)
function handleMakeSelection(makeText, index, container) {
  const firstLevelBtnSpan = container.querySelector('.first-level-btn span');
  const secondLevelBtn = container.querySelector('.second-level-btn');
  const secondLevelBtnSpan = container.querySelector('.second-level-btn span');
  const secondLevel = container.querySelector('.second-level');
  const thirdLevelBtn = container.querySelector('.third-level-btn');
  const firstLevel = container.querySelector('.first-level');
  const thirdLevel = container.querySelector('.third-level');
  
  // Update button text to show selection
  if (firstLevelBtnSpan) firstLevelBtnSpan.textContent = `MAKE - ${makeText.toUpperCase()}`;
  
  // Track the make selection
  window.VehicleSelection.setMake(makeText, index);
  
  // Show only the lineups for the selected make
  const secondLevelUls = container.querySelectorAll('.second-level ul');
  secondLevelUls.forEach(ul => ul.classList.remove('active'));
  const targetUl = secondLevelUls[index % secondLevelUls.length];
  if (targetUl) targetUl.classList.add('active');
  
  // Hide first level, show ONLY second level
  if (firstLevel) firstLevel.classList.remove('active');
  if (secondLevel) secondLevel.classList.add('active');
  
  // Enable second level button
  if (secondLevelBtn) {
    secondLevelBtn.disabled = false;
    secondLevelBtn.classList.remove('btn-disabled');
    secondLevelBtn.classList.add('active');
    secondLevelBtn.style.cursor = 'pointer';
  }
  
  // Reset second level button text
  if (secondLevelBtnSpan) secondLevelBtnSpan.textContent = 'SELECT LINEUP';
  
  // Hide and disable third level
  if (thirdLevel) thirdLevel.classList.remove('active');
  if (thirdLevelBtn) {
    //thirdLevelBtn.disabled = true;
    //thirdLevelBtn.classList.add('btn-disabled');
    //thirdLevelBtn.classList.remove('active');
  }
  
  // If in modal, update unlocked levels and show level 2
  const modal = container.closest('dialog');
  if (modal) {
    const unlockedLevels = modal.dataset.unlockedLevels ? JSON.parse(modal.dataset.unlockedLevels) : [1];
    if (!unlockedLevels.includes(2)) {
      unlockedLevels.push(2);
      modal.dataset.unlockedLevels = JSON.stringify(unlockedLevels);
    }
    showMobileLevel(modal, 2);
  }
}

// Unified handler for lineup selection
function handleLineupSelection(lineupText, lineupIndex, makeIndex, container) {
  const secondLevelBtnSpan = container.querySelector('.second-level-btn span');
  const thirdLevelBtn = container.querySelector('.third-level-btn');
  const thirdLevelBtnSpan = container.querySelector('.third-level-btn span');
  const thirdLevel = container.querySelector('.third-level');
  const secondLevel = container.querySelector('.second-level');
  const firstLevel = container.querySelector('.first-level');
  
  // Update button text to show selection
  if (secondLevelBtnSpan) secondLevelBtnSpan.textContent = `LINEUP - ${lineupText.toUpperCase()}`;
  
  // Track the lineup selection
  window.VehicleSelection.setLineup(lineupText, lineupIndex, makeIndex);
  
  // Calculate the absolute index for the model UL
  // We need to count how many lineups (and thus third-level ULs) come before this one
  let absoluteLineupIndex = 0;
  const allSecondLevelUls = container.querySelectorAll('.second-level ul');
  
  // Add up all lineups from previous makes
  for (let i = 0; i < makeIndex; i++) {
    absoluteLineupIndex += allSecondLevelUls[i].children.length;
  }
  
  // Add the lineup index within the current make
  absoluteLineupIndex += lineupIndex;
  
  // Show only the models for the selected lineup
  const thirdLevelUls = container.querySelectorAll('.third-level ul');
  thirdLevelUls.forEach(ul => ul.classList.remove('active'));
  
  const targetUl = thirdLevelUls[absoluteLineupIndex];
  if (targetUl) {
    targetUl.classList.add('active');
  }
  
  // Hide second level, show ONLY third level
  if (secondLevel) secondLevel.classList.remove('active');
  if (firstLevel) firstLevel.classList.remove('active');
  if (thirdLevel) thirdLevel.classList.add('active');
  
  // Enable third level button
  if (thirdLevelBtn) {
    //thirdLevelBtn.disabled = false;
    //thirdLevelBtn.classList.remove('btn-disabled');
    //thirdLevelBtn.classList.add('active');
  }
  
  // Reset third level button text
  if (thirdLevelBtnSpan) thirdLevelBtnSpan.textContent = 'SELECT MODEL';
  
  // If in modal, update unlocked levels and show level 3
  const modal = container.closest('dialog');
  if (modal) {
    const unlockedLevels = modal.dataset.unlockedLevels ? JSON.parse(modal.dataset.unlockedLevels) : [1];
    if (!unlockedLevels.includes(3)) {
      unlockedLevels.push(3);
      modal.dataset.unlockedLevels = JSON.stringify(unlockedLevels);
    }
    showMobileLevel(modal, 3);
  }
  
  // Scroll the active UL into view
  setTimeout(() => {
    const activeUl = thirdLevel?.querySelector('ul.active');
    if (activeUl) activeUl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, 100);
}

// Unified handler for model selection
function handleModelSelection(modelText, modelIndex, container) {
  
  const thirdLevelBtnSpan = container.querySelector('.third-level-btn span');
  
  // Update button text to show selection
  if (thirdLevelBtnSpan) thirdLevelBtnSpan.textContent = `MODEL - ${modelText.toUpperCase()}`;
  
  // Track the model selection and complete
  const makeIndex = window.VehicleSelection.make ? window.VehicleSelection.make.index : 0;
  const lineupIndex = window.VehicleSelection.lineup ? window.VehicleSelection.lineup.index : 0;
  window.VehicleSelection.setModel(modelText, modelIndex, lineupIndex, makeIndex);
  
  // Update filter button summary if in filter mode  
  const isFilter = container.classList.contains('select-your-vehicle-filter');
  if (isFilter) {
    updateFilterSummary();
    
    // Apply vehicle filters by checking the metaobject filter checkboxes
    applyVehicleFilters();
  }
  
  // Close the filter details if in filter mode
  const detailsElement = container.closest('details');
  if (detailsElement) detailsElement.open = false;
}

// Track if we've initialized click handlers to prevent duplicates
let clickHandlersInitialized = false;

// Main initialization function
function initializeVehicleSelection() {
  // Prevent multiple initializations
  if (clickHandlersInitialized) return;
  
  /** @type {HTMLDialogElement | null} */
  const modal = /** @type {HTMLDialogElement | null} */ (document.getElementById('vehicle-modal'));
  const isInModal = modal && modal.open && window.innerWidth < 750;
  const selectors = getContextSelectors(modal, !!isInModal);
  
  clickHandlersInitialized = true;
  
  // Initialize click handlers
  initializeClickHandlers(selectors, modal, !!isInModal);
}

// Extracted click handler initialization logic
/**
 * @param {any} selectors
 * @param {HTMLDialogElement | null} modal
 * @param {boolean} isInModal
 */
function initializeClickHandlers(selectors, modal, isInModal) {
  // WORKAROUND: Use event delegation on the details element since child elements have zero dimensions
  const detailsElement = document.getElementById('Details-VehicleFilter');
  if (detailsElement) {
    
    detailsElement.addEventListener('click', function(event) {
      const target = /** @type {HTMLElement} */ (event.target);
      // Also prevent link clicks within filter mode models
      if (target.tagName === 'A' && target.closest('.third-level') && target.closest('.select-your-vehicle-filter')) {
        //event.preventDefault();
        console.log('target', target);
        return;
      }else{
      // Check if clicked on a button to navigate back to a level
      const filterContainer = detailsElement.querySelector('.select-your-vehicle-filter');
      
      if (target.closest('.first-level-btn') || target.closest('.first-level-btn span')) {
        // Show first level, hide others
        const firstLevel = filterContainer?.querySelector('.first-level');
        const secondLevel = filterContainer?.querySelector('.second-level');
        const thirdLevel = filterContainer?.querySelector('.third-level');
        const firstLevelChevron = filterContainer?.querySelector('.first-level-btn .chevron-toggle');
        const secondLevelChevron = filterContainer?.querySelector('.second-level-btn .chevron-toggle');
        const thirdLevelChevron = filterContainer?.querySelector('.third-level-btn .chevron-toggle');
        
        if (firstLevel) firstLevel.classList.add('active');
        if (secondLevel) secondLevel.classList.remove('active');
        if (thirdLevel) thirdLevel.classList.remove('active');
        
        // Chevron up when expanded (viewing options), down when collapsed
        if (firstLevelChevron) {
          firstLevelChevron.classList.remove('chevron-down');
          firstLevelChevron.classList.add('chevron-up');
        }
        if (secondLevelChevron) {
          secondLevelChevron.classList.remove('chevron-up');
          secondLevelChevron.classList.add('chevron-down');
        }
        if (thirdLevelChevron) {
          thirdLevelChevron.classList.remove('chevron-up');
          thirdLevelChevron.classList.add('chevron-down');
        }
        return;
      }
      
      if (target.closest('.second-level-btn') || target.closest('.second-level-btn span')) {
        // Show second level, hide others
        const firstLevel = filterContainer?.querySelector('.first-level');
        const secondLevel = filterContainer?.querySelector('.second-level');
        const thirdLevel = filterContainer?.querySelector('.third-level');
        const firstLevelChevron = filterContainer?.querySelector('.first-level-btn .chevron-toggle');
        const secondLevelChevron = filterContainer?.querySelector('.second-level-btn .chevron-toggle');
        const thirdLevelChevron = filterContainer?.querySelector('.third-level-btn .chevron-toggle');
        
        if (firstLevel) firstLevel.classList.remove('active');
        if (secondLevel) secondLevel.classList.add('active');
        if (thirdLevel) thirdLevel.classList.remove('active');
        
        // Chevron up when expanded (viewing options), down when collapsed
        if (firstLevelChevron) {
          firstLevelChevron.classList.remove('chevron-up');
          firstLevelChevron.classList.add('chevron-down');
        }
        if (secondLevelChevron) {
          secondLevelChevron.classList.remove('chevron-down');
          secondLevelChevron.classList.add('chevron-up');
        }
        if (thirdLevelChevron) {
          thirdLevelChevron.classList.remove('chevron-up');
          thirdLevelChevron.classList.add('chevron-down');
        }
        return;
      }
      
      if (target.closest('.third-level-btn') || target.closest('.third-level-btn span')) {
        // Show third level, hide others
        const firstLevel = filterContainer?.querySelector('.first-level');
        const secondLevel = filterContainer?.querySelector('.second-level');
        const thirdLevel = filterContainer?.querySelector('.third-level');
        const firstLevelChevron = filterContainer?.querySelector('.first-level-btn .chevron-toggle');
        const secondLevelChevron = filterContainer?.querySelector('.second-level-btn .chevron-toggle');
        const thirdLevelChevron = filterContainer?.querySelector('.third-level-btn .chevron-toggle');
        
        if (firstLevel) firstLevel.classList.remove('active');
        if (secondLevel) secondLevel.classList.remove('active');
        if (thirdLevel) thirdLevel.classList.add('active');
        
        // Chevron up when expanded (viewing options), down when collapsed
        if (firstLevelChevron) {
          firstLevelChevron.classList.remove('chevron-up');
          firstLevelChevron.classList.add('chevron-down');
        }
        if (secondLevelChevron) {
          secondLevelChevron.classList.remove('chevron-up');
          secondLevelChevron.classList.add('chevron-down');
        }
        if (thirdLevelChevron) {
          thirdLevelChevron.classList.remove('chevron-down');
          thirdLevelChevron.classList.add('chevron-up');
        }
        return;
      }
      
      // Check if clicked element is a vehicle make LI (filter version)
      if (target.tagName === 'LI' && target.hasAttribute('data-vehicle-make') && target.closest('.first-level') && target.closest('.select-your-vehicle-filter')) {
        const makeText = target.textContent.trim();
        const index = Array.from(target.parentElement.children).indexOf(target);
        const filterContainer = detailsElement.querySelector('.select-your-vehicle-filter');
        if (filterContainer) handleMakeSelection(makeText, index, filterContainer);
      }
      
      // Check if clicked element is a lineup LI (filter version)
      if (target.tagName === 'LI' && target.closest('.second-level') && !target.closest('.first-level') && !target.closest('.third-level') && target.closest('.select-your-vehicle-filter')) {
        const lineupText = target.textContent.trim();
        const secondLevelUl = target.closest('ul');
        const makeIndex = secondLevelUl ? Array.from(secondLevelUl.parentElement.children).indexOf(secondLevelUl) : 0;
        const lineupIndex = secondLevelUl ? Array.from(secondLevelUl.children).indexOf(target) : 0;
        const filterContainer = detailsElement.querySelector('.select-your-vehicle-filter');
        if (filterContainer) handleLineupSelection(lineupText, lineupIndex, makeIndex, filterContainer);
      }
      
      // Check if clicked element is a model LI (filter version)
      if (target.tagName === 'LI' && target.closest('.third-level') && !target.closest('.first-level') && !target.closest('.second-level') && target.closest('.select-your-vehicle-filter')) {
        //event.preventDefault(); // Prevent navigation in filter mode
        const modelText = target.textContent.trim();
        const thirdLevelUl = target.closest('ul');
        const modelIndex = thirdLevelUl ? Array.from(thirdLevelUl.children).indexOf(target) : 0;
        const filterContainer = detailsElement.querySelector('.select-your-vehicle-filter');
        if (filterContainer) handleModelSelection(modelText, modelIndex, filterContainer);
      }
      
    }
    }, true);
  }
  
  // First level click handler
  if (selectors.firstLevelItems) {
    selectors.firstLevelItems.forEach(/** @param {Element} item @param {number} index */ (item, index) => {
      // Use addEventListener with capture phase to intercept clicks before bubbling
      item.addEventListener('click', function(event) {
        event.stopPropagation();
        event.preventDefault();
        
        const makeText = this.textContent.trim();
        const container = this.closest('.select-your-vehicle, .select-your-vehicle-filter');
        if (container) handleMakeSelection(makeText, index, container);
      }, true); // true = use capture phase
    });
  }

  // Second level click handler
  if (selectors.secondLevelItems) {
    selectors.secondLevelItems.forEach(/** @param {Element} item */ item => {
      if (/** @type {any} */ (item).secondLevelClickHandler) item.removeEventListener('click', /** @type {any} */ (item).secondLevelClickHandler);
      
      /** @type {any} */ (item).secondLevelClickHandler = function() {
        const parentUl = this.closest('ul');
        const container = this.closest('.select-your-vehicle, .select-your-vehicle-filter');
        
        // Find the second level container within the current container context
        const secondLevelContainer = container ? container.querySelector('.second-level') : null;
        const allSecondLevelUls = secondLevelContainer ? Array.from(secondLevelContainer.querySelectorAll('ul')) : [];
        const makeIndex = parentUl ? allSecondLevelUls.indexOf(parentUl) : -1;
        
        const lineupText = this.textContent.trim();
        const lineupIndex = parentUl ? Array.from(parentUl.children).indexOf(this) : -1;
        
        if (container) handleLineupSelection(lineupText, lineupIndex, makeIndex, container);
      };
      
      item.addEventListener('click', /** @type {any} */ (item).secondLevelClickHandler);
    });
  }

  // Third level click handler
  if (selectors.thirdLevelItems) {
    selectors.thirdLevelItems.forEach(/** @param {Element} item */ item => {
      if (/** @type {any} */ (item).thirdLevelClickHandler) item.removeEventListener('click', /** @type {any} */ (item).thirdLevelClickHandler);
      
      /** @type {any} */ (item).thirdLevelClickHandler = function() {
        const modelText = this.textContent.trim();
        const parentUl = this.closest('ul');
        const modelIndex = Array.from(parentUl.children).indexOf(this);
        const container = this.closest('.select-your-vehicle, .select-your-vehicle-filter');
        if (container) handleModelSelection(modelText, modelIndex, container);
      };
      
      item.addEventListener('click', /** @type {any} */ (item).thirdLevelClickHandler);
    });
  }
}

// Wait for DOM to be ready
let initialized = false;


function initializeVehicleScript() {
  if (initialized) return;
  initialized = true;
  
  // Load saved vehicle selection from localStorage
  window.VehicleSelection.loadFromStorage();
  
  // Restore vehicle selection state on page load if vehicle filters are in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const hasVehicleFilters = urlParams.has('filter.p.m.custom.vehicle_make') || 
                            urlParams.has('filter.p.m.custom.vehicle_model') || 
                            urlParams.has('filter.p.m.custom.vehicle_lineup');
  
  if (hasVehicleFilters) {
    restoreVehicleSelectionState();
  }

  // Initial availability styling on DOM ready
  try { initVehicleAvailability(); } catch (e) { /* no-op */ }
  
  // Track if we're clearing all filters to prevent restore (global flag)
  window.isClearingAllFilters = false;
  
  // Listen for filter updates and restore vehicle selection state after section re-renders
  // The filter:update event fires before the async section rendering completes,
  // so we need to wait for the DOM to actually update
  document.addEventListener('filter:update', () => {
    setTimeout(() => {
      restoreVehicleSelectionState(true); // Pass true to skip if clearing
      // Re-apply availability styling after facets refresh
      initVehicleAvailability(document);
    }, 1000);
  });
  
  // Listen for clear all filters button clicks
  // Use event delegation since the button may be re-rendered
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target) return;
    
    // Check if the clicked element is a clear all button
    const clearAllButton = target.closest('.facets__clear-all');
    if (clearAllButton) {
      // Set flag to prevent restore
      window.isClearingAllFilters = true;
      
      // Clear the vehicle selection immediately
      clearVehicleSelection();
      
      // Reset flag after filter update completes
      setTimeout(() => {
        window.isClearingAllFilters = false;
      }, 2000);
    }
  });
  
  const vehicleBtn = document.getElementById('vehicle-selector-btn');
  const vehicleFilterBtn = document.getElementById('vehicle-selector-filter-btn');
  const vehicleContent = document.getElementById('vehicle-content');
  
  // Also check for filter version
  const vehicleContentFilter = document.getElementById('vehicle-content-filter');
  const activeVehicleContent = vehicleContent || vehicleContentFilter;
  
  // Look for menu in both header and filter containers
  const headerMenu = vehicleContent ? vehicleContent.querySelector('.select-your-vehicle') : null;
  const filterMenu = vehicleContentFilter ? vehicleContentFilter.querySelector('.select-your-vehicle-filter') : null;
  const vehicleMenu = headerMenu || filterMenu;
    
    
    /** @type {HTMLDialogElement | null} */
    const vehicleModal = /** @type {HTMLDialogElement | null} */ (document.getElementById('vehicle-modal'));
    const modalContent = document.getElementById('vehicle-modal-content');
    const modalCloseBtn = vehicleModal ? vehicleModal.querySelector('.vehicle-modal__close') : null;
    
    // Check if we're on mobile
    function isMobile() {
      return window.innerWidth < 750;
    }
    
    // Handle header button
    const chevronIcon = vehicleBtn ? vehicleBtn.querySelector('.chevron-toggle') : null;
    if (vehicleBtn && chevronIcon && vehicleMenu) {
      // Button click listener
      vehicleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (isMobile()) {
          // Move content to modal on mobile
          if (vehicleMenu && modalContent) {
            modalContent.innerHTML = '';
            modalContent.appendChild(vehicleMenu.cloneNode(true));
            
                        // Open modal
                        if (vehicleModal) {
                          // Initialize unlocked levels (start with level 1)
                          vehicleModal.dataset.unlockedLevels = JSON.stringify([1]);
                          
                          vehicleModal.showModal();

                          // Position modal to the right after opening
                          setTimeout(() => {
                            vehicleModal.style.position = 'fixed';
                            vehicleModal.style.top = '0';
                            vehicleModal.style.right = '0';
                            vehicleModal.style.left = 'auto';
                            vehicleModal.style.margin = '0';
                            vehicleModal.style.transform = 'none';
                          }, 0);

                          // Show first level initially on mobile
                          showMobileLevel(vehicleModal, 1);
              
              // Wait a bit for modal to render, then initialize event listeners
              setTimeout(() => {
                initializeVehicleSelectionForModal(vehicleModal);
              // Apply availability styling inside modal copy
              initVehicleAvailability(vehicleModal);
              }, 100);
              
              // Focus the close button for accessibility
              if (modalCloseBtn) {
                /** @type {HTMLElement} */ (modalCloseBtn).focus();
              }
            }
          }
        } else {
          // Toggle dropdown on desktop
          
          if(vehicleContent){
            const isOpen = vehicleContent.classList.contains('active');
            if (isOpen) {
              // Close menu
              vehicleContent.classList.remove('active');
              chevronIcon.classList.remove('chevron-up');
              chevronIcon.classList.add('chevron-down');
            } else {
              // Open menu - reset vehicle selection
              window.VehicleSelection.reset();
              
              vehicleContent.classList.add('active');
              chevronIcon.classList.remove('chevron-down');
              chevronIcon.classList.add('chevron-up');
              // Apply availability styling when opening the dropdown
              initVehicleAvailability(vehicleContent);
            
            }
          }
        }
      });
      
      // Close modal when close button is clicked
      if (modalCloseBtn) {
        modalCloseBtn.addEventListener('click', function() {
          if (vehicleModal) {
            vehicleModal.close();
          }
        });
      }
      
      // Close modal when clicking on backdrop
      if (vehicleModal) {
        vehicleModal.addEventListener('click', function(event) {
          if (event.target === vehicleModal) {
            vehicleModal.close();
          }
        });
      }
      
      // Close menu when clicking outside (desktop only)
      document.addEventListener('click', function(event) {
        if (!isMobile()) {
          /** @type {Node | null} */
          const target = /** @type {Node | null} */ (event.target);
          const isClickOnButton = target === vehicleBtn || (vehicleBtn && vehicleBtn.contains(target));
          const isClickOnContent = vehicleContent && vehicleContent.contains(target);
          
          if (!isClickOnButton && !isClickOnContent) {
            if (vehicleContent) vehicleContent.classList.remove('active');
            if (chevronIcon) {
              chevronIcon.classList.remove('chevron-up');
              chevronIcon.classList.add('chevron-down');
            }
          }
        }
      });
      
      // Handle window resize to switch between modal and dropdown
      let resizeTimer;
      let lastWidth = window.innerWidth;
      
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const currentWidth = window.innerWidth;
          const widthDiff = Math.abs(currentWidth - lastWidth);
          
          // Only act on significant resize (more than 50px change)
          if (widthDiff > 50) {
            if (isMobile() && vehicleModal && vehicleModal.open) {
              // If resizing to mobile while modal is open, keep it open
              return;
            } else if (!isMobile() && vehicleModal && vehicleModal.open) {
              // If resizing to desktop while modal is open, close it
              vehicleModal.close();
            } else if (!isMobile() && vehicleContent && vehicleContent.classList.contains('active')) {
              // If resizing to desktop while content is open, keep it open
            }
            lastWidth = currentWidth;
          }
        }, 250); // Wait 250ms after resize stops
      });
      
      // Initialize event listeners for desktop on page load
      initializeVehicleSelection();
    }
    
    // Track if we've added navigation handlers
    if (!window.vehicleNavigationHandlersAdded) {
      window.vehicleNavigationHandlersAdded = true;
      
      // Add level button click handlers for navigation (only once)
      document.addEventListener('click', function(event) {
        /** @type {Element | null} */
        const target = /** @type {Element | null} */ (event.target);
        const firstLevelBtn = target ? target.closest('.first-level-btn') : null;
        const secondLevelBtn = target ? target.closest('.second-level-btn') : null;
        const thirdLevelBtn = target ? target.closest('.third-level-btn') : null;
        
        if (firstLevelBtn && !/** @type {HTMLButtonElement} */ (firstLevelBtn).disabled) {
          event.preventDefault();
          /** @type {HTMLDialogElement | null} */
          const modal = /** @type {HTMLDialogElement | null} */ (document.getElementById('vehicle-modal'));
          const isInModal = modal && modal.open && window.innerWidth < 750;
          
          // Determine which container this button is in
          const isFilterButton = firstLevelBtn.closest('.select-your-vehicle-filter');
          const containerSelector = isFilterButton ? '.select-your-vehicle-filter' : '.select-your-vehicle';
          
          if (isInModal) {
            showMobileLevel(modal, 1);
          } else {
            // Desktop: show first level, hide others - only in the correct container
            const container = document.querySelector(`.vehicle-content ${containerSelector}`);
            if (container) {
              const firstLevel = container.querySelector('.first-level');
              const secondLevel = container.querySelector('.second-level');
              const thirdLevel = container.querySelector('.third-level');
              
              if (firstLevel) {
                firstLevel.classList.add('active');
              }
              if (secondLevel) {
                secondLevel.classList.remove('active');
              }
              if (thirdLevel) {
                thirdLevel.classList.remove('active');
              }
            }
          }
        }
        
        if (secondLevelBtn && !/** @type {HTMLButtonElement} */ (secondLevelBtn).disabled) {
          event.preventDefault();
          /** @type {HTMLDialogElement | null} */
          const modal = /** @type {HTMLDialogElement | null} */ (document.getElementById('vehicle-modal'));
          const isInModal = modal && modal.open && window.innerWidth < 750;
          
          // Determine which container this button is in
          const isFilterButton = secondLevelBtn.closest('.select-your-vehicle-filter');
          const containerSelector = isFilterButton ? '.select-your-vehicle-filter' : '.select-your-vehicle';
          
          if (isInModal) {
            showMobileLevel(modal, 2);
          } else {
            // Desktop: show second level, hide others - only in the correct container
            const container = document.querySelector(`.vehicle-content ${containerSelector}`);
            if (container) {
              const firstLevel = container.querySelector('.first-level');
              const secondLevel = container.querySelector('.second-level');
              const thirdLevel = container.querySelector('.third-level');
              
              if (firstLevel) {
                firstLevel.classList.remove('active');
              }
              if (secondLevel) {
                secondLevel.classList.add('active');
              }
              if (thirdLevel) {
                thirdLevel.classList.remove('active');
              }
            }
          }
        }
        
        if (thirdLevelBtn && !/** @type {HTMLButtonElement} */ (thirdLevelBtn).disabled) {
          event.preventDefault();
          /** @type {HTMLDialogElement | null} */
          const modal = /** @type {HTMLDialogElement | null} */ (document.getElementById('vehicle-modal'));
          const isInModal = modal && modal.open && window.innerWidth < 750;
          
          // Determine which container this button is in
          const isFilterButton = thirdLevelBtn.closest('.select-your-vehicle-filter');
          const containerSelector = isFilterButton ? '.select-your-vehicle-filter' : '.select-your-vehicle';
          
          if (isInModal) {
            showMobileLevel(modal, 3);
          } else {
            // Desktop: show third level, hide others - only in the correct container
            const container = document.querySelector(`.vehicle-content ${containerSelector}`);
            if (container) {
              const firstLevel = container.querySelector('.first-level');
              const secondLevel = container.querySelector('.second-level');
              const thirdLevel = container.querySelector('.third-level');
              
              if (firstLevel) {
                firstLevel.classList.remove('active');
              }
              if (secondLevel) {
                secondLevel.classList.remove('active');
              }
              if (thirdLevel && !thirdLevel.classList.contains('active')) {

                thirdLevel.classList.add('active');
                
                // Also show the active UL inside the third level
                const activeUl = thirdLevel.querySelector('ul.active');
                if (activeUl) {
                  // Use setAttribute to force the entire style attribute
                  activeUl.setAttribute('style', 'list-style: none !important; padding: 0 !important; margin: 0 !important; width: 100% !important; display: block !important; visibility: visible !important;');
                }
              }
            }
          }
        }
      });
    } // End of navigation handlers guard
    
    // Handle filter button (different behavior than header button)
    const filterDetails = document.getElementById('Details-VehicleFilter');
    
    // Track if we've already initialized the filter version
    let filterInitialized = false;
    
    // Changed condition - filterMenu might not exist yet on page load, but will exist when filter opens
    if (vehicleFilterBtn && filterDetails) {
      // DON'T use modal for filter version - use inline dropdown on both mobile and desktop
      // Listen for the details toggle event
      filterDetails.addEventListener('toggle', function(e) {
        if (filterDetails.open && !filterInitialized) {
          // Details just opened, initialize the vehicle selection
          setTimeout(() => {
            // Query for the filter menu inside the content div
            const vehicleContentFilterDiv = document.getElementById('vehicle-content-filter');
            const freshFilterMenu = vehicleContentFilterDiv ? vehicleContentFilterDiv.querySelector('.select-your-vehicle-filter') : null;
            
            if (freshFilterMenu) {
              // Ensure the details element is properly sized
              const detailsElement = document.getElementById('Details-VehicleFilter');
              if (detailsElement) {
                detailsElement.style.minHeight = 'auto';
              }
              
              // Ensure the floating panel container is visible and has dimensions
              if (vehicleContentFilterDiv) {
                vehicleContentFilterDiv.style.setProperty('display', 'block', 'important');
                vehicleContentFilterDiv.style.setProperty('visibility', 'visible', 'important');
                vehicleContentFilterDiv.style.setProperty('opacity', '1', 'important');
                vehicleContentFilterDiv.style.setProperty('min-height', '200px', 'important');
                
                // On mobile, use static positioning to push content down
                const isMobile = window.innerWidth < 750;
                if (isMobile) {
                  vehicleContentFilterDiv.style.setProperty('position', 'static', 'important');
                  vehicleContentFilterDiv.style.setProperty('width', '100%', 'important');
                  vehicleContentFilterDiv.style.setProperty('max-width', '100%', 'important');
                  vehicleContentFilterDiv.style.setProperty('margin-top', '0', 'important');
                  vehicleContentFilterDiv.style.setProperty('border-radius', '0', 'important');
                  vehicleContentFilterDiv.style.setProperty('border-left', 'none', 'important');
                  vehicleContentFilterDiv.style.setProperty('border-right', 'none', 'important');
                } else {
                  vehicleContentFilterDiv.style.setProperty('position', 'absolute', 'important');
                  vehicleContentFilterDiv.style.setProperty('width', '300px', 'important');
                  vehicleContentFilterDiv.style.setProperty('max-width', '90vw', 'important');
                }
              }
              
              // Ensure the menu wrapper is visible and has dimensions
              freshFilterMenu.style.display = 'block';
              freshFilterMenu.style.visibility = 'visible';
              freshFilterMenu.style.minHeight = '100px';
              freshFilterMenu.style.width = '100%';
              
              // Ensure ONLY first level is active on initial open
              const firstLevel = freshFilterMenu.querySelector('.first-level');
              const secondLevel = freshFilterMenu.querySelector('.second-level');
              const thirdLevel = freshFilterMenu.querySelector('.third-level');
              const secondLevelBtn = freshFilterMenu.querySelector('.second-level-btn');
              const thirdLevelBtn = freshFilterMenu.querySelector('.third-level-btn');
              
              // Show only first level
              if (firstLevel) {
                firstLevel.classList.add('active');
              }
              if (secondLevel) {
                secondLevel.classList.remove('active');
              }
              if (thirdLevel) {
                thirdLevel.classList.remove('active');
              }
              
              // Disable level buttons
              if (secondLevelBtn) {
                /** @type {HTMLButtonElement} */ (secondLevelBtn).disabled = true;
                secondLevelBtn.classList.add('btn-disabled');
                secondLevelBtn.classList.remove('active');
              }
              if (thirdLevelBtn) {
                /** @type {HTMLButtonElement} */ (thirdLevelBtn).disabled = true;
                thirdLevelBtn.classList.add('btn-disabled');
                thirdLevelBtn.classList.remove('active');
              }
              
              initializeVehicleSelection();
              filterInitialized = true; // Mark as initialized so we don't do it again
            }
          }, 100);
        }
      });
    }
}

if (!initialized) {
  document.addEventListener('DOMContentLoaded', initializeVehicleScript);
}

// Also try to initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
} else {
  // DOM is already loaded, initialize immediately
  initializeVehicleScript();
}

// Expose openVehicleModal globally for inline onclick handlers
window.openVehicleModal = openVehicleModal;
